export default {
  state: {
    token: undefined,
    userinfo: {}
  },
  mutations: {
    setToken(state, token) {
      if (token == undefined) {
        sessionStorage.removeItem('Dlv-Auth')
      } else {
        sessionStorage.setItem('Dlv-Auth', token)
      }
      state.token = token
    },
    setUser(state, user) {
      state.userinfo = user
    }
  },
  actions: {
    async loadUserinfo({dispatch, commit}) {
      let r = await dispatch('apiQuery', {method: '/auth/userinfo'})
      await commit('setUser', r)
    },
    async login({dispatch, commit, getters}, token) {
      const $t = getters.localePhrase
      await dispatch('setGlobalLoading', $t('Вход в учетную запись'))
      await commit('setToken', token)
      await dispatch('loadUserinfo')
      
      // if login was successfull, load everything
      try{
        await dispatch('init_stream')
      }catch(e){
        console.log(e)
      }
      await dispatch('initApplication')
    },
    async tryLogin({dispatch}) {
      let token = sessionStorage.getItem('Dlv-Auth')
      if (token) {
        await dispatch('login', token)
      } else {
        await dispatch('setGlobalLoading') // stop loading if there is no auth info
      }
    },
    async clearAuth({commit}) {
      await commit('setToken', undefined)
      await commit('setUser', {})
    },
    async logout({dispatch, getters}) {
      const $t = getters.localePhrase
      await dispatch('setGlobalLoading', $t('Выход из системы'))
      try {
        await dispatch('apiQuery', {method: '/auth/logout'})
      } finally {
        await dispatch('clearAuth')
        await dispatch('setGlobalLoading', undefined)
      }
    },
    async addAdmin({dispatch, commit}, {login, password}) {
      await commit('setConfig', await dispatch('apiQuery', {method:'/add_admin', body: {login, password}}))
    },
    async removeAdmin({dispatch, commit}, {login}) {
      await commit('setConfig', await(dispatch('apiQuery', {method: '/remove_admin', body: {login}})))
    }
  },
  getters: {
    token(state){
      return state.token
    },
    user(state) {
      return state.userinfo
    }
  }
}